<template>
  <InSharesTable
    :show-edit-action="false"
    :show-in-share-detail-link="false"
    :show-responsible-tooltip="false"
    :show-user-count="false"
  />
</template>

<script lang="ts" setup>
import InSharesTable from '@/components/deepbox/in-shares/InSharesTable.vue'

definePage({
  meta: {
    breadcrumbLabelKey: 'navigation.personal.my_in_shares',
  },
})
</script>
